'use strict';

import './typModal.scss';
import template from './typModal.template.html';
import controller from './typModal.controller.js';

const component = {
    bindings: {
        listingId: '@',
        isDealerInspire: '<',
        hasChatEnabled: '<',
        dealerInspireSmsNumber: '@'
    },
    controller,
    template
};

export default component;
